import { store } from "../store/configureStore";
import { systemLabelActions } from "../store/actions/system/systemLabel/systemLabel.action";
import routes from "../routes";
import {history} from "./history";

export const labelHelper = new (function() {
    this.loadingLabels = [];
 this.getLabelValue = name => {
    const { location } = history;
    let activeRoute = routes.find(r => {
      return this.comparePaths(location.pathname, r.path);
    });
    const groupName = activeRoute.labelGroup;
    const { systemLabels, authentication } = store.getState();
    const { groups } = systemLabels;
    const { user } = authentication;
    let group = null;
    let label = null;
    if (groups !== undefined) {
      group = groups[groupName];
    } else if(systemLabels.loading === false) {
        store.dispatch(systemLabelActions.getAllGroups())
    }
    if (group) {
      label = group.find(l => {
        return l.name === name && l.languageCode === user.userLang;
      });
      if (!label && !this.loadingLabels.some(ll => {
        return ll === name;
      })) {

        store.dispatch(
          systemLabelActions.create(name, user.userLang, groupName)
        );
        this.loadingLabels.push(name);
      } else if (label) {
        this.loadingLabels = this.loadingLabels.filter(ll => {
            return ll !== name;
          });
        if (label.hint) {
          return `${label.value} <i class='fa fa-info-circle' title="${
            label.hint
          }"></i>`;
        } else {
          return label.value;
        }
      }
      else{
          return `*${name}*`;
      }
    } else if (!this.loadingLabels.some(ll => {
        return ll === name;
      })) {
        this.loadingLabels.push(name);
      store.dispatch(systemLabelActions.create(name, user.userLang, groupName));
    }
  };
  this.comparePaths = (p1, p2) => {

    if (p1.includes('/register/') && p2.includes('/register/')) {
      return true;
    }
    if (p1.includes('/survey/') && p2.includes('/survey/')) {
      return true;
    }
    if (p1.includes('/editor/') && p2.includes('/editor/')) {
      return true;
    }
    if (p1.includes('/digitalmeeting/') && p2.includes('/digitalmeeting/')) {
      return true;
    }
    if (p1.includes('/session/moderator/') && p2.includes('/session/moderator/')) {
      return true;
    }
    if (p1.includes('/session/client/') && p2.includes('/session/client/')) {
      return true;
    }
    if (p1.includes('/presenter/') && p2.includes('/presenter/')) {
      return true;
    }
    if (p1.includes('/session/stage/') && p2.includes('/session/stage/')) {
      return true;
    }
    if (p1.includes('/session/chatmoderator/') && p2.includes('/session/chatmoderator/')) {
      return true;
    }
    if (p1.includes('/exhibitor/') && p2.includes('/exhibitor/')) {
      return true;
    }
    if (p1.includes('/booth/') && p2.includes('/booth/')) {
      return true;
    }
    const locRegex = /\/\d+.*/gi;
    const pathRegex = /\/:id/gi;
    p1 = p1.replace(locRegex, "").replace(pathRegex, "").toLowerCase();
    p2 = p2.replace(locRegex, "").replace(pathRegex, "").toLowerCase();
    return p1 === p2;
  };

  return {
    getLabel: this.getLabelValue
  };
})();
